import { Modal, Space } from "antd";
import type { ReactNode } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { HookAPI } from "antd/es/modal/useModal";

type Props = {
  icon?: ReactNode;
  textIntlKey?: string;
  handleConfirm?: (modal: HookAPI) => void;
  handleDelete: () => void;
  loading?: boolean;
  confirmModalTitleIntlKey?: string;
  confirmModalContentIntlKey?: string;
  itemName: string
}

export const TableRowActionDelete = ({
                                   icon,
                                   textIntlKey,
                                   handleConfirm,
                                   handleDelete,
                                   loading,
                                   confirmModalTitleIntlKey,
                                   confirmModalContentIntlKey,
                                   itemName
                                 }: Props) => {
  const [modal, contextHolder] = Modal.useModal();
  const { formatMessage } = useIntl();
  const onClickHandler = () => {
    if (handleConfirm) {
      handleConfirm(modal);
    } else {
      modal.confirm({
        title: formatMessage({ id: confirmModalTitleIntlKey || "delete" }),
        content: formatMessage({ id: confirmModalContentIntlKey || "delete.confirm" }, { item: itemName}),
        okText: formatMessage({ id: "delete" }),
        okButtonProps: { loading: loading },
        onOk: () => handleDelete(),
      });
    }
  }

  return (
    <>
      {contextHolder}
      <Space onClick={onClickHandler}>
        {icon && icon}
        {<FormattedMessage id={textIntlKey || 'delete'}/>}
      </Space>
    </>
  );
}